import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "module", "ignoreAuth", "fallback"];
import React, { Suspense } from 'react';
import { useMixedContextValue } from '@lumahealthhq/ui-components';
import { Box, ErrorBoundary, Typography } from '@lumahealthhq/ui-core';
import { useCurrentAuth, usePermissions } from '@lumahealthhq/ui-model';
import { useLogger } from '@lumahealthhq/ui-utils';
import { useModuleProducts } from '../../hooks';
import useFallbackRender from './hooks/useFallbackRender';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ModuleWrapper(_ref) {
  var children = _ref.children,
    module = _ref.module,
    ignoreAuth = _ref.ignoreAuth,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback,
    rest = _objectWithoutProperties(_ref, _excluded);
  var logger = useLogger();
  var auth = useCurrentAuth();
  var fallbackRender = useFallbackRender(module);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, deprecation/deprecation
  var debug = useMixedContextValue('debug');
  var _usePermissions = usePermissions(),
    permissions = _usePermissions.permissions,
    hasAccessToProduct = _usePermissions.hasAccessToProduct;
  var productsRequired = useModuleProducts(module);

  // Prevent rendering the module in case the auth is not initialized yet
  if (!ignoreAuth && !auth) {
    return null;
  }
  if (!fallbackRender || !hasAccessToProduct(productsRequired)) {
    logger.error("Heads up! We're trying to render a module without permissions", {
      module: module,
      productsRequired: productsRequired.join(','),
      permissions: permissions
    });
    return null;
  }
  return /*#__PURE__*/_jsx(ErrorBoundary, _extends({
    fallbackRender: fallbackRender
  }, rest, {
    children: /*#__PURE__*/_jsx(Suspense, {
      fallback: fallback,
      children: debug ?
      /*#__PURE__*/
      // Additional info for debug mode
      _jsxs(Box, {
        sx: {
          position: 'relative'
        },
        children: [children, debug && /*#__PURE__*/_jsx(Box, {
          sx: function sx(theme) {
            return {
              zIndex: theme.zIndex.tooltip + 1,
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              border: "1px solid ".concat(theme.palette.error.main),
              m: '1px',
              color: theme.palette.error.main,
              pointerEvents: 'none'
            };
          },
          children: /*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'inline-block',
              bgcolor: 'white',
              px: 0.5
            },
            children: /*#__PURE__*/_jsxs(Typography, {
              variant: "caption",
              children: [module, ": [", productsRequired.join(','), "]"]
            })
          })
        })]
      }) : children
    })
  }));
}